export const contacts = {
	phone: ["+234 703 802 5454", "+234 818 296 3338", "+234 802 659 1104"],
	whatsapp: "+234 810 405 5881",
	email: "info@abinneprojects.com",
	address: [
		"Ogwuru Okorie Compound,\nOgboko Ozuitem\nBende LGA\nAbia State.",
		"Eghem Layout Umuahia,\nAbia State.",
	],
};

export const vision =
	"To  be a symbol of a new vista in Intelligence, Security, and Service delivery.";

export const missionStatement = "To make a difference on Service delivery.";

export const foundersPromise =
	"MY Promise to our Clients, is to be a confidant, a strategist, and an expert source of your demands. We shall be candid, and you should be too, And together, we meet your expectations.";

export const coreValues = {
	acronym: "HI TEAM",
	values: [
		"Honesty",
		"Integrity",
		"Trust",
		"Excellent Service",
		"Accountability",
		"Mutual Respect",
	],
};

export const about =
	"Abinne Projects International Limited is a dynamic Company with Staff who had over 35 years experience in Security, Intelligence, Operations, Investigations, Election matters, Mediation, Oil and Gas affairs, Special Services, Technical matters, Buildings, Security education, Training among others. The company is dedicated to serving our clients confidentially in areas of needs.";

export const services = [
	{
		name: "CONSULTANCY",
		image: "consultancy-icon.svg",
		outlines: [
			"Security matters",
			"Intelligence affairs",
			"Projects inspections",
			"Security Appraisals/Re Appraisals",
			"Election strategies",
			"Mediation/Crisis management",
			"Negotiations",
			"Survey(security, market, etc)",
		],
	},
	{
		name: "TECHNICAL",
		image: "technical-icon.svg",
		outlines: [
			"Security Gadgets",
			"Installations",
			"Security building/Building security",
		],
	},
	{
		name: "INVESTIGATIONS",
		image: "investigations-icon.svg",
		outlines: ["Security/Intelligence", "Investigations/breaches", "Vettings"],
	},
	{
		name: "EDUCATION/TRAINING",
		image: "education-icon.svg",
		outlines: [
			"Security/Intelligence education",
			"Security/Intelligence Training",
			"Lectures",
			"Position paper",
			"Computer Training etc",
		],
	},
];

export const projects = [
	{
		name: "Mediations",
		images: [
			"mediations-1.jpg",
			"mediations-2.jpg",
			"mediations-3.jpg",
			"mediations-4.jpg",
		],
	},
	{
		name: "Investigations",
		images: [
			"investigations-1.jpg",
			"investigations-2.jpg",
			"investigations-3.jpg",
			"investigations-4.jpg",
			"investigations-5.jpg",
		],
	},
];

export const founder = {
	name: "Chukwuma C. Ogwuru",
	image: "cc-ogwuru.jpg",
	position: "Founder/ Consultant",
	bio: "CC Ogwuru is the Founder of Abinne Projects International Limited. As a veritable member of the Nigeria Intelligence Community, he is offering a fresh perspective on security as a desirable asset in a seamless suit of fidelity, integrity and versality. Mr Ogwuru is result driven, focused and pragmatic; and has over 35 years experience spanning all facets of Intelligence, Security, Mediation, Operations and Related Assignments.\nHe attended various courses on Intelligence, Operations, management, Administration and conflict resolution. He is a good manager of human and material resources as a result of which he awards/commendations from various civilian and military intelligence and Security Agencies during a long meritorious service with the DSS.\n\nHis tenacity and resolve earned him many commendations including but not limited to the following:\n- Results achieved in Investigations carried out to resolve economic crimes;\n-Operational applications of strategic Thinking resulting in several success of difficult operations;\n-Formulation and implementation of strategic measures which resulted in First ever peaceful Elections in volatile areas such as JosNorth,Plateau State etc;\n-Playing strategic and mediatory roles in resolving crisis in Niger Delta Areas;\n- Singlehandedly resolved Hijacked incident at CONOIL Platform, Akassa, Bayelsa State etc.\n\nOgwuru has held Command and Strategic positions. Among them were: Deputy Director, Security Enforcement in various States, PA to Director of Operations,DSS Headquarters,Abuja; Component Commander,Joint Task Force; Principal Staff Officer Investigations, Operations and Vetting respectively in various years; Security Liaison Officer Oil and Gas;. Mediator for host communities and multinational companies; Staff officer Strategic Communications;  Staff Officer Special Duties, ICPC, Abuja. He also served in the Contract Verification Committee of the ICPC as Pioneer Chairman; and as a pioneer and DSS Representative in the Committee on Establishment of the EFCC. He is an Author of professional books.\nHe is equipped and enabled, with a knowledgeable and dependable Team, to steer ABINNE PROJECTS INTERNATIONAL LIMITED on determined path of desirable results.",
};

export const team = [
	{
		name: "Chukwuma C. Ogwuru",
		image: "cc-ogwuru.jpg",
		position: "Founder/ Consultant",
		bio: "CC Ogwuru is the Founder of Abinne Projects International Limited. As a veritable member of the Nigeria Intelligence Community, he is offering a fresh perspective on security as a desirable asset in a seamless suit of fidelity, integrity and versality. Mr Ogwuru is result driven, focused and pragmatic; and has over 35 years experience spanning all facets of Intelligence, Security, Mediation, Operations and Related Assignments.\nHe attended various courses on Intelligence, Operations, management, Administration and conflict resolution. He is a good manager of human and material resources as a result of which he awards/commendations from various civilian and military intelligence and Security Agencies during a long meritorious service with the DSS.\n\nHis tenacity and resolve earned him many commendations including but not limited to the following:\n- Results achieved in Investigations carried out to resolve economic crimes;\n-Operational applications of strategic Thinking resulting in several success of difficult operations;\n-Formulation and implementation of strategic measures which resulted in First ever peaceful Elections in volatile areas such as JosNorth,Plateau State etc;\n-Playing strategic and mediatory roles in resolving crisis in Niger Delta Areas;\n- Singlehandedly resolved Hijacked incident at CONOIL Platform, Akassa, Bayelsa State etc.\n\nOgwuru has held Command and Strategic positions. Among them were: Deputy Director, Security Enforcement in various States, PA to Director of Operations,DSS Headquarters,Abuja; Component Commander,Joint Task Force; Principal Staff Officer Investigations, Operations and Vetting respectively in various years; Security Liaison Officer Oil and Gas;. Mediator for host communities and multinational companies; Staff officer Strategic Communications;  Staff Officer Special Duties, ICPC, Abuja. He also served in the Contract Verification Committee of the ICPC as Pioneer Chairman; and as a pioneer and DSS Representative in the Committee on Establishment of the EFCC. He is an Author of professional books.\nHe is equipped and enabled, with a knowledgeable and dependable Team, to steer ABINNE PROJECTS INTERNATIONAL LIMITED on determined path of desirable results.",
	},
	{
		name: "Kio Andrew Smart",
		image: "smart.jpg",
		position: "Consultant/Coordinator South South.",
		bio: "Smart is the coordinator for South South Operations. A member Intelligence Community with 35 years experience in all facets of Intelligence, Security, Mediation, Operations, and Related Assignments. He attended numerous courses during his stint at DSS.\nHe held strategic positions within and outside the Service. And has the ability to work with abstract of problems and think outside the security norms to achieve resounding success.",
	},
	{
		name: "Chukwudi Nwosu",
		image: "nwosu.jpg",
		position: "Coordinator 11, South East",
		bio: "Nwosu is a specialist with professional records in Electrical/Electronics Engineering. He is a founding CEO of Dandy Electrical Technology. A team builder and has networks of friends spanning different professional fields. He is coordinator 11 for APIL operations in IMO and Anambra States.",
	},
	{
		name: "Victor Omoareb",
		image: "avatar.png",
		position: "Consultant",
		bio: "Omoareb background in Architecture,gives him a sophisticated grasp on even the most complicated aspect of building and programming. He spent several years working as Architect and several more years as CEO heading a design team that designed many Buildings with security in-depth.",
	},
	{
		name: "Dickson Otioda",
		image: "avatar.png",
		position: "Consultant/Coordinator, North Central",
		bio: "Otioda is a creative thinker with an extensive background on Information Technology and Public Relation Education. He is worked with several Local Government Chairmen as Personal Assistant. He Coordinates activities of APIL in North Central, Nigeria.",
	},
	{
		name: "Emmanuel Ezugwu",
		image: "avatar.png",
		position: "Consultant/South East Operations",
		bio: "Ezugwu had 35 years experience spanning all facets of Intelligence, Security, and Operations. He held Command positions and attended various professional courses. His tenacity, loyalty and resourcefulness,endeared him to his superiors. He once,served under the command of CC Ogwuru, Founder APIL, as Staff Officer Operations.",
	},
];

export const faq = [
	{
		id: 1,
		question:
			"Q: WHAT IS UNIQUE ABOUT APIL?\nA: The uniqueness of APIL stems from the following",
		answers: [
			"It provides a platform that allows easy access to the synergy of the uniquely varied expertise, experience and cognate competence of its promoters.",
			"It promotes an operational model that places high emphasis on Corporate Social Responsibility exemplified by its sponsorship of two dedicated NGOs.",
			"APIL through its top Advisers brings a new deal to the table! It has an impactful new solution to Security, Intelligence, Technical, Electoral and Field logistics that is significantly different from those in existence presently.",
			"At APIL, we accord great respect to academic achievements with commensurate field display of competency, expertise and seamless service delivery.",
			"If you are PECULIAR, with a pioneering instinct; if you have the qualities required to engineer a unique Brand; APIL is for YOU!\nPlease welcome on board! Do contact the CEO through a text message on WhatsApp no 0810 405 5881.",
		],
	},
	{
		id: 2,
		question:
			"Q: WHAT SPECIAL SERVICES WOULD APIL RENDER?\nA: Our special services include the following:",
		answers: [
			"We will engender trust and fidelity in your relationships with others such as in matrimonial, corporate, social, political and/or domestic engagements.",
			"We will provide reliable information/data required for successful execution of your preferred projects as it concerns security, intelligence and the fidelity of all parties involved.",
			"You need not worry about the integrity of your corporate and domestic staff as we will have you covered on that by ensuring that only individuals withproven reliability are placed at your disposal.",
			"As a Business entity and a Political Aspirant we will place helpful information and reliable logistics about your environment that will guarantee success.",
		],
	},
	{
		id: 3,
		question:
			"Q: HOW DO YOU ASSIST IN ELECTION MATTERS?\nA: Trust APIL to provide the leverage you need in the following ways:",
		answers: [
			"We provide basic guides on the WHY, WHEN and HOW to contest elective positions",
			"We have a model strategy that ensures success through accurate identification, interpretation and application of the Strength, Weakness, Opportunity, Threat, Action Plan (SWOTAP) that are at play in every election process.",
			"Popularity and Acceptability are significant election winners! Trust APIL to provide you with reliable facts on your strength in a particular Ward, Community, State, or Region you are aspiring to represent,",
			"Our team at APIL will provide you with requisite grooming; and work with you to ensure that your electioneeringtrain stay ahead of the rest in planning and execution.",
			"APIL will be on ground and keep you abreast of daily events in your constituency; and we will give you an honest and candid answer on your chances of winning. ",
			"Are you an aspiring Politician? Are you ready to excite the political scene? Do you want to cultivate unusual die hard followership? Are you contesting any upcoming elecion? Do you want to have a WINNING TEAM or train your own team to be WINNERS? If your answers are YES,,,you have no better partner than APIL,",
		],
	},
	{
		id: 4,
		question: "Q: WHAT DO YOU MEAN BY BUILDING SECURITY AND SECURITY BUILDING?",
		answers: [
			"APIL in talking about BUILDING SECURITY emphasizes what we call “INWARD SECURITY” It is more than providing armed guards, barbed wires, bullet proof doors et al, Real estate developers, builders, need to consider “INWARD SECURITY” when embarking on building projects, You need intelligence input on how to build your home, APIL provides indebt input on Security conscious Intelligence based architectural design.",
			"On SECURITY BUILDING: our classification of buildings as such is not limited to the status of its occupant and/or type of activities being carried out in it; or things/materials being stored in them, APIL specialises in providing reappraisal of architectural integrity of buildings to ensure that right from inception and/or renovation they provide secure and reliable protection from untoward events ",
		],
	},
];
